module.exports = __webpack_public_path__ + "static/media/live_costs_white-01.401ffd1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/live_costs_white-01.png
// module id = 7696
// module chunks = 0